import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';

import { Modal, Button, TextField } from 'shared';
import { useThemeToggle } from 'hooks/useThemeToggle';
import { handleErrorAlert } from 'utils/handleErrorAlert';
import { handleSuccessAlert } from 'utils/handleSuccessAlert';
import { useInventoryService } from 'store/services/inventory.service';
import { notesText, plaidTransactionNotesModalStyles } from 'components/Inventory/style/style';

const PlaidTransactionNotesModal = ({
    transaction,
    setAlertData,
    showNotesModal,
    setShowNotesModal,
    handleNoteSuccess,
}) => {
    const { themeMode } = useThemeToggle();
    const classes = plaidTransactionNotesModalStyles();
    const companyData = useSelector((state) => state.company.data);
    const { isLoading, updatePlaidTransactionNotes } = useInventoryService();

    const [note, setNote] = useState(transaction?.inventory_notes);

    const handleUpdateTransactionNote = async () => {
        try {
            if (note != transaction?.inventory_notes) {
                const response = await updatePlaidTransactionNotes({
                    company_id: companyData?.id,
                    note,
                    plaid_transaction_id: transaction?.id,
                });
                handleSuccessAlert(setAlertData, response.message);
                handleNoteSuccess();
            }
            setShowNotesModal(false);
        } catch (error) {
            handleErrorAlert(setAlertData);
        }
    };

    return (
        <Modal
            fullWidth={true}
            open={showNotesModal}
            title="Transaction Notes"
            handleClose={() => setShowNotesModal(false)}
            showFooter
            footer={
                <Box display="flex" justifyContent="flex-end" gap={2}>
                    <Button
                        sx={classes.cancelButton}
                        text="Cancel"
                        onClick={() => setShowNotesModal(false)}
                    />
                    <Button
                        text={transaction?.inventory_notes ? 'Update' : 'Add'}
                        loading={isLoading}
                        onClick={handleUpdateTransactionNote}
                    />
                </Box>
            }
        >
            <Box>
                <TextField
                    multiline
                    rows={3}
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="Add a note"
                    fullWidth
                    InputProps={{
                        style: notesText(themeMode),
                    }}
                />
            </Box>
        </Modal>
    );
};

export default PlaidTransactionNotesModal;
